import React, { useState } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import Vendor from "./Vendor";
import RegisteredVendors from "./RegisteredVendors";
import { decryptText } from "../utility/cryptoUtils";
import RegisteredEventVendors from "./RegisteredEventVendors";


const VendorTab = () => {

  const email = decryptText(localStorage.getItem("email"))?.toLowerCase(); // 👈 added



  const [tabValue, setTabValue] = useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Paper
      sx={{
        bgcolor: "#1e1e1e",
        color: "white",
        px: 2,
        py: 3,  
        borderRadius: 2,
        // minHeight: "85vh",
      }}
    >
      {/* ---- Tabs Header ---- */}
      <Tabs
        value={tabValue}
        onChange={handleChange}
        textColor="inherit"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          borderBottom: "1px solid #343a40",
          "& .MuiTab-root": {
            fontWeight: "bold",
            textTransform: "none",
          },
        }}
      >
        <Tab  label="Vendor Management" />
        <Tab label="Registered Vendors" />
        <Tab label="Registered Event Vendors" />
      </Tabs>

      {/* ---- Tab Panels ---- */}
      <Box sx={{ mt: 3 }}>
        {tabValue === 0 && <Vendor />}
        {tabValue === 1 && <RegisteredVendors />}
        {tabValue === 2 && <RegisteredEventVendors />}
      </Box>
    </Paper>
  );
};

export default VendorTab;
